import { render, staticRenderFns } from "./spinner-dot.vue?vue&type=template&id=235e7ef2&scoped=true&"
import script from "./spinner-dot.vue?vue&type=script&lang=js&"
export * from "./spinner-dot.vue?vue&type=script&lang=js&"
import style0 from "./spinner-dot.vue?vue&type=style&index=0&id=235e7ef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e7ef2",
  null
  
)

export default component.exports